// extracted by mini-css-extract-plugin
export default {"item_wrapper":"ObjectItem_item_wrapper__FrYBe","image_wrapper":"ObjectItem_image_wrapper__NdIVk","title":"ObjectItem_title__5ry1n"};